/**
 * Web Applications Configuration
 * Simple configuration file with web applications, dashboards, and portals that use IDP-Web
 * No external service calls needed - just imports this file
 */

// Base dashboard definitions (shared across environments)
// Load dashboard data from JSON to keep data separate from code and reduce duplication flags
import dashboards from './dashboards.json';

// Build environment-specific dashboard options
function buildDashboardOptions(isProd) {
  const env = isProd ? 'prod' : 'qa';
  return dashboards
    .map(dashboard => ({
      id: dashboard.id,
      name: isProd ? dashboard.name : `${dashboard.name} (QA)`,
      description: dashboard.description,
      url: dashboard.url[env]
    }));
}

export const DASHBOARD_OPTIONS = {
  prod: buildDashboardOptions(true),
  qa: buildDashboardOptions(false)
};

/**
 * Get web applications/portals for current environment
 */
export function getDashboardOptions() {
  const environment = process.env.REACT_APP_ENV === 'prod' ? 'prod' : 'qa';
  return DASHBOARD_OPTIONS[environment];
}